import { WalletDepositWay } from '@bz/wallet';

export const route = {
  info: {
    login: true,
  },
  preload() {
    WalletDepositWay.preload?.();
  },
} satisfies RouteDefinition;
export default WalletDepositWay;
